import { watchFetchInventory } from './fetchInventory';

export const inventorySagas = [watchFetchInventory()];
